import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import vueImages from "vue-images";
import 'jquery';
import 'element-ui/lib/theme-chalk/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import "./assets/countdown/jquery.countdown.css";
import "./assets/themes/themes.css";
import 'swiper/dist/css/swiper.css';
import VueParticles from 'vue-particles'   //背景特效
import ChoiceTemplate from './choicetemplate.vue'

//官网模板组件 
import XDheader from './components/xd-header.vue'
import XDfooter from './components/xd-footer.vue'
import XDcountdown from './components/xd-countdown.vue'
import XDswiper from './components/xd-swiper.vue'
import XDmediaPartner from './components/xd-mediaPartner.vue'
import XDright from './components/xd-right.vue'
//官网模板
import HomeTemplate from './template/home/1-home.vue'
import HomeTemplate2 from './template/home/2-home.vue'
import HomeTemplate3 from './template/home/3-home.vue'



Vue.use(VueParticles) //背景特效
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.use(require('vue-moment'));

Vue.component('XDmediaPartner',XDmediaPartner);
Vue.component('XDswiper',XDswiper);
Vue.component('XDcountdown',XDcountdown);
Vue.component('XDheader',XDheader);
Vue.component('XDfooter',XDfooter);
Vue.component('XDright',XDright)

Vue.component('vue-images', vueImages);
Vue.component('choiceTemplate',ChoiceTemplate);
Vue.component('HomeTemplate',HomeTemplate);
Vue.component('HomeTemplate2',HomeTemplate2);
Vue.component('HomeTemplate3',HomeTemplate3);


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js